import internalStateService from "../../app/InternalStateService";
import { WEBUILogs } from "@tinqin/tinqin-utils/src/logging";
import ApiError from "./ApiError";
import { executeRequest } from "./requestService";

//interface for http requests
//Example options:
// options: {
//     payload: payload,
//     method: "POST",
//     endpoint: endpoint,
//     headers: {
//         "Content-Type": "multipart/form-data"
//     }
// }
export function request(options = {}, context = {}) {
    let payload;
    //in case of get request no need of request body
    if (options.method !== "GET") {
        payload = options.payload;
    }
    let projectHttpHeaders = internalStateService.getGlobalProperties("projectHttpHeaders");
    let headers = options.headers || {};
    if (projectHttpHeaders) {
        Object.assign(headers, projectHttpHeaders);
    }
    let widgetContextPath;
    if (context.widgetId) {
        widgetContextPath = internalStateService.getWidgetContextPath(context.widgetId);
    }

    return (dispatch, getState) =>
        executeRequest(
            {
                options: {
                    types: [],
                    method: options.method,
                    endpoint: options.endpoint,
                    headers: headers,
                    rawEndpointUrl: options.rawEndpointUrl,
                    contextPath: widgetContextPath
                },
                payload: payload
            },
            getState()
        ).then(
            //success
            response => {
                if (isJSONResponse(response)) {
                    return response.json().then(json => dispatch(handleResponse(json, context)));
                } else {
                    WEBUILogs.warn("Server response not in JSON format.");
                    return Promise.resolve(response);
                }
            },
            //fail
            response => {
                if (isJSONResponse(response)) {
                    return response.json().then(json => {
                        let error = new ApiError(response.status, response.statusText, json);
                        if (json.message) {
                            error.setMessage(json.message);
                        }
                        return Promise.reject(error);
                    });
                }
                if (isPlainTextResponse(response)) {
                    return response.text().then(responseText => {
                        let error = new ApiError(
                            response.status,
                            response.statusText,
                            responseText
                        );
                        error.setMessage(responseText);
                        return Promise.reject(error);
                    });
                }
                return Promise.reject(new ApiError(response.status, response.statusText, response));
            }
        );
}

function isJSONResponse(response) {
    let contentType = response.headers.get("Content-Type") || "";
    return contentType.indexOf("json") !== -1;
}

function isPlainTextResponse(response) {
    let contentType = response.headers.get("Content-Type") || "";
    return contentType.indexOf("text/plain") !== -1;
}

function onWidgetNotFound(response, context) {
    const setWidgetErrorState = internalStateService.getActionByName("widget.setWidgetErrorState");
    let widgetState = {
        state: "warning",
        message: response.message
    };
    return dispatch => dispatch(setWidgetErrorState(context.widgetId, widgetState));
}

function handleResponse(response, context) {
    return async dispatch => {
        let hasContent = response.hasOwnProperty("content");
        let hasActions = response.hasOwnProperty("actions");
        let hasStatus = response.hasOwnProperty("status");
        //check for response format using "status" field
        if (hasActions && hasStatus) {
            const dispatchSirenActions = internalStateService.getActionByName(
                "siren.dispatchSirenActions"
            );
            dispatch(dispatchSirenActions(response.actions, context.widgetId));
        }

        if (response.status === "failure") {
            let responseFailure = Object.assign({}, response);
            if (hasContent) {
                let responseContent = Object.assign({}, response.content);
                if (response.type === "multiTarget") {
                    responseContent.collectiveResponse = true;
                    responseFailure.content = responseContent;
                }
            }

            return Promise.reject(responseFailure);
        }
        if (hasContent) {
            if (response.status === "error") {
                if (context.widgetId) {
                    return Promise.reject(dispatch(onWidgetNotFound(response.content, context)));
                }
            }
            let responseContent = Object.assign({}, response.content);
            if (response.type === "multiTarget") {
                responseContent.collectiveResponse = true;
            }
            return Promise.resolve(responseContent);
        }
        response.fullResponse = true;
        return Promise.resolve(response);
    };
}
